<script setup lang="ts">
import {BarChartWidget} from "@/laboratory/components/dashboard/dashboard";
import {computed} from "vue";
import {
    ArcElement,
    BarElement,
    CategoryScale,
    Chart as ChartJS,
    Filler,
    Legend,
    LinearScale,
    Title,
    Tooltip
} from "chart.js";
import type {ChartOptions} from "chart.js";
import {Bar as BarChart} from 'vue-chartjs';
import ChartDataLabels from "chartjs-plugin-datalabels";
import {Widget} from "@/laboratory/components/dashboard/components/widget";
import ChartService from "@/laboratory/services/ChartService";

ChartJS.register(Title, Tooltip, Legend, Filler, BarElement, CategoryScale, LinearScale, ArcElement);


const props = defineProps<{
    widget: BarChartWidget;
}>();

/**
 * The chart options.
 */
const chartOptions = computed<ChartOptions<'bar'>>(() => {
    return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: true,
            },
            datalabels: {
                color: "primary",
                anchor: "end",
                offset: -3,
                align: "top",
                font: {
                    size: 8
                },
                formatter: (value: number) => {
                    return value;
                }
            },
        },
        scales: {
            y: {
                ticks: {
                    callback: (tickValue: string | number) => {
                        return tickValue;
                    },
                },
            },
            x: {
                ticks: {
                    autoSkip: false,
                    font: {
                        size: 9,
                    },
                },
            },
        },
    };
});

const chartData = computed(() => {
    return {
        labels: props.widget.data.labels,
        datasets: props.widget.data.datasets.map((dataset, index) => {
            return {
                label: dataset.label,
                data: dataset.values,
                backgroundColor: dataset.color || ChartService.getColor(index),
            };
        }),
    };
});
</script>

<template>
  <Widget :widget="widget">
    <BarChart class="flex flex-1 h-96 relative" :data="chartData" :plugins="[ChartDataLabels as any]" :options="chartOptions" />
  </Widget>
</template>

<style scoped>

</style>
